function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6599 21.1388L20.2112 18.2789C20.9346 17.219 21.372 15.9405 21.372 14.561C21.372 10.944 18.428 8 14.811 8C11.194 8 8.25 10.944 8.25 14.561C8.25 18.178 11.194 21.122 14.811 21.122C16.1905 21.122 17.469 20.6846 18.5289 19.9612L21.3888 23.4099C21.4561 23.4772 21.5234 23.5613 21.6075 23.6286C22.2973 24.2006 23.3066 24.0997 23.8786 23.4099C24.4506 22.7202 24.3497 21.7108 23.6599 21.1388ZM9.98278 14.5778C9.98278 11.903 12.153 9.73278 14.8278 9.73278C17.5027 9.73278 19.6729 11.903 19.6729 14.5778C19.6729 17.2527 17.4859 19.406 14.8278 19.406C12.153 19.406 9.98278 17.2359 9.98278 14.5778Z",
  fill: "black"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 32C25.0866 32 32.25 24.8366 32.25 16C32.25 7.16344 25.0866 0 16.25 0C7.41344 0 0.25 7.16344 0.25 16C0.25 24.8366 7.41344 32 16.25 32Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.afb08965.svg";
export { ForwardRef as ReactComponent };